import { Validators } from '@angular/forms';
import { IColumnConfigTableResponsive } from 'src/app/domain/IColumnConfigTableResponsive';
import { FieldTypeEnum } from 'src/app/domain/registration/enums/field-type.enum';
import { serviceOrderPriorityEnum } from 'src/app/domain/registration/enums/service-order-priority.enum';
import { ServiceOrdersStatusEnum } from 'src/app/domain/registration/enums/service-orders-status.enum';
import { serviceOrderTypeEnum } from 'src/app/domain/registration/enums/serviceOrder-type.enum';
import { SystemsExternalTypeEnum, SystemsExternalTypeIdEnum } from 'src/app/domain/registration/enums/system-external-type.enum';
import { SystemTypeEnum, SystemTypeIdEnum } from 'src/app/domain/registration/enums/system-type.enum';
import { TableResponsiveTypeColumnEnum } from 'src/app/domain/registration/enums/table-responsive-type-column.enum';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';
import { TypeOriginSystemEnum } from 'src/app/domain/registration/enums/type-origin-system.enum';
import { CustomerIndexSelectComponent } from '../customers/crud-index/crud-index-select.component';
import { SystemModuleSelectComponent } from '../customers/customer-plan-items/system-modules-select/system-module-select.component';
import { PartnerIndexMultiSelectComponent } from '../partners/crud-index/crud-index-multiselect.component';
import { SystemsExternalIndexSelectComponent } from '../systems-external/crud-index/crud-index-select.component';
import { SystemIndexSelectComponent } from '../systems/crud-index/crud-index-select.component';
export const RELATIVE_URL = 'service-orders';

export const COLUMNS_TO_SHOW_WEB = [
  'select',
  'code',
  'image',
  'partners',
  'title',
  'fileType',
  'priority',
  'module',
  'customers',
  'locationSummary',
  'logisticsSummary',
  'createdAt',
  'estimation',
  'cost',
  'status',
  'actions',

];

export const COLUMNS_TO_SHOW_MOBILE = COLUMNS_TO_SHOW_WEB;

export const TABLE_CONFIG_COLUMNS: IColumnConfigTableResponsive[] = [
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'code',
    display: 'OS',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'systemsExternal',
    display: 'ORIGEM',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'systemDestiny',
    display: 'SISTEMA DE DESTINO',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'originInternal',
    display: 'SISTEMA DE ORIGEM INTERNO',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'system',
    display: 'SISTEMA',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'priority',
    display: 'PRIORIDADE',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: false,
    property: 'module',
    display: 'MÓDULO',
    maxLength: 15,
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: false,
    property: 'partners',
    display: 'SOLICITANTE',
    maxLength: 20,
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: false,
    property: 'customers',
    display: 'CLIENTE',
    maxLength: 15,
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: false,
    property: 'locationSummary',
    display: 'LOCALIZAÇÃO',
    maxLength: 24,
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: false,
    property: 'logisticsSummary',
    display: 'LOGÍSTICA',
    maxLength: 24,
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'createdAt',
    display: 'CRIADO EM',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'approval',
    display: 'APROVAÇÃO',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'rejection',
    display: 'REJEIÇÃO',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'estimation',
    display: 'ESTIMATIVA',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'cost',
    display: 'CUSTO',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'response',
    display: 'RESPOSTA',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'status',
    display: 'STATUS',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'fileType',
    display: 'TIPO', 
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: false,
    property: 'title',
    display: 'TÍTULO',
    maxLength: 20,
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'description',
    display: 'DESCRIÇÃO DO ARQUIVO',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  },
  
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'fileAttachment', 
    display: 'ARQUIVO', 
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'video',
    display: 'VIDEO',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`, 
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'imageFile',
    display: 'IMAGEM',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: false,
    property: 'image',
    display: 'SOLUÇÃO',
    maxLength: 15,
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'database',
    display: 'BANCO DE DADOS',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'fileSize',
    display: 'TAMANHO DO ARQUIVO',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'fileFormat',
    display: 'FORMATO DO ARQUIVO',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column text-align-center`,
  },

];

export const CES_CONFIG_FIELDS = [
  {
    type: TypeComponentFieldEnum.HIDDEN,
    name: 'id',
  },
  {
    type: TypeComponentFieldEnum.SELECT_CRUD,
    label: 'SOLICITANTE',
    component: PartnerIndexMultiSelectComponent,
    name: 'partners',
    value: 'name',
    defaultValue: ' ',
    options: [Object.values([])],
    placeholder: 'Selecione uma opção',
    validation: [],
  },
  {
    type: TypeComponentFieldEnum.SELECT_CRUD,
    label: 'MODULO',
    component: SystemModuleSelectComponent,
    componentData: {
      params: {}
    },
    name: 'module',
    value: 'name',
    defaultValue: ' ',
    options: [Object.values([])],
    placeholder: 'Selecione um módulo',
    validation: [],
  },
  {
    type: TypeComponentFieldEnum.SELECT_CRUD,
    label: 'CLIENTE',
    component: CustomerIndexSelectComponent,
    name: 'customers',
    value: 'name',
    defaultValue: ' ',
    options: [Object.values([])],
    placeholder: 'Selecione uma opção',
    validation: [],
  },
  {
    type: TypeComponentFieldEnum.SELECT_CRUD,
    label: 'Solução/produto',
    component: SystemIndexSelectComponent,
    name: 'system',
    value: 'name',
    defaultValue: ' ',
    options: [Object.values([])],
    placeholder: 'Selecione uma opção',
    validation: [],
  },
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'TIPO', 
    name: 'fileType',
    options: Object.values(serviceOrderTypeEnum),
    placeholder: 'Selecione uma opção',
    validators: [Validators.required],
  },
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'PRIORIDADE',
    name: 'priority',
    options: Object.values(serviceOrderPriorityEnum),
    validators: [Validators.required],
  },
  {
    type: TypeComponentFieldEnum.INPUT_DATETIME,
    label: 'DATA PREVISTA',
    name: 'estimation',
    validators: [],
  },
  {
    type: TypeComponentFieldEnum.INPUT_FILE,
    label: 'ARQUIVO', 
    name: 'fileAttachment', 
    validators: [],
  },
  {
    type: TypeComponentFieldEnum.INPUT_FILE,
    label: 'VIDEO', 
    name: 'video', 
    validators: [],
  },
  {
    type: TypeComponentFieldEnum.INPUT_FILE,
    label: 'IMAGEM', 
    name: 'imageFile', 
    validators: [],
  },
  {
    type: TypeComponentFieldEnum.INPUT_FILE,
    label: 'BANCO DE DADOS', 
    name: 'database',
    validators: [],
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'TÍTULO',
    name: 'title',
    validators: [Validators.required],
  },
  {
    type: TypeComponentFieldEnum.INPUT_TEXT_AREA,
    label: 'COMENTARIO',
    name: 'fileDescription',
    validators: [Validators.required, Validators.maxLength(5000)],
    maxLength: 5000,
  },
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'ORIGEM DA SOLUÇÃO', 
    name: 'typeOrigin',
    options: Object.values(TypeOriginSystemEnum),
    placeholder: 'Selecione uma opção',
    validators: [],
  },
  // SISTEMA DE ORIGEM EXTERNO
  {
    type: TypeComponentFieldEnum.SELECT_CRUD,
    label: 'SISTEMA EXTERNO',
    component: SystemsExternalIndexSelectComponent,
    componentData: {
      params: { type: SystemsExternalTypeIdEnum[SystemsExternalTypeEnum.SYSTEM] },
    },
    name: 'systemsExternal',
    value: 'name',
    defaultValue: ' ',
    options: [Object.values([])],
    placeholder: 'Selecione uma opção',
    validation: [],
  },
  // SISTEMA DE ORIGEM INTERNO ALFASU
  {
    type: TypeComponentFieldEnum.SELECT_CRUD,
    label: 'SISTEMA ORIGEM',
    component: SystemIndexSelectComponent,
    componentData: {
      params: { type: SystemTypeIdEnum[SystemTypeEnum.SYSTEM] },
    },
    name: 'originInternal',
    value: 'name',
    defaultValue: ' ',
    options: [Object.values([])],
    placeholder: 'Selecione uma opção',
    validation: [],
  },
  {
    type: TypeComponentFieldEnum.SELECT_CRUD,
    label: 'SISTEMA DE DESTINO',
    component: SystemIndexSelectComponent,
    componentData: {
      params: { type: SystemTypeIdEnum[SystemTypeEnum.SYSTEM] },
    },
    name: 'systemDestiny',
    value: 'name',
    defaultValue: ' ',
    options: [Object.values([])],
    placeholder: 'Selecione uma opção',
    validation: [],
  },
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'STATUS',
    name: 'status',
    options: Object.values(ServiceOrdersStatusEnum),
    validators: [],
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'USUÁRIO RESPONSÁVEL',
    name: 'UserResponseName',
    disabled: true,
    validators: [],
  },
  {
    labelSave: 'Salvar',
    labelCancel: 'Cancelar',
    name: 'cancelSave',
    type: TypeComponentFieldEnum.CANCEL_SAVE,
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'Custo',
    name: 'cost',
    validators: [],
  },
  {
    type: TypeComponentFieldEnum.CHECKBOX,
    label: 'Contrato assinado',
    name: 'contractSigned',
    validators: [],
  },
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'Tipo de cancelamento',
    name: 'cancellationType',
    options: ['IMEDIATO', 'AGENDADO'],
    validators: [],
  },
  {
    type: TypeComponentFieldEnum.INPUT_DATETIME,
    label: 'Data de cancelamento agendado',
    name: 'scheduledCancellationDate',
    validators: [],
  },
];
